document.addEventListener("DOMContentLoaded", () => {
  const thumbs = new Swiper(".sp-gallery__thumbs-swiper", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
  });

  const imageGallery = new Swiper(".sp-gallery__main-swiper", {
    spaceBetween: 12,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbs,
    },
  });

  const mobileAppSwiperContainer = document.querySelector(".mobile-app-swiper");
  const mobileAppSwiperThumbnailContainer = document.querySelector(
    ".mobile-app-thumbnail"
  );
  const itemCount = mobileAppSwiperThumbnailContainer.dataset.slideCount;
  const mobileAppSwiper = new Swiper(mobileAppSwiperContainer, {});
  const mobileAppThumbnailSwiper = new Swiper(
    mobileAppSwiperThumbnailContainer,
    {
      slidesPerView: 1.5,
      spaceBetween: 10,
      breakpoints: {
        990: {
          grid: {
            rows: Number(itemCount),
          },
          slidesPerView: 1,
          spaceBetween: 16,
        },
      },
    }
  );

  mobileAppSwiper.on("activeIndexChange", (swiper) => {
    const idx = swiper.activeIndex;
    mobileAppThumbnailSwiper.slideTo(swiper.activeIndex);
    const activated = mobileAppThumbnailSwiper.slides.find((item) => {
      return item.classList.contains("activated");
    });
    activated.classList.toggle("activated");
    mobileAppThumbnailSwiper.slides[idx].classList.toggle("activated");
  });

  mobileAppSwiperThumbnailContainer
    .querySelectorAll(".swiper-slide")
    .forEach((slide, idx) => {
      slide.addEventListener("click", (item) => {
        mobileAppSwiper.slideTo(idx);
      });
    });
});
